;(function(){
  try {
    var key = Object.getOwnPropertyNames(window).find(function(k){ return k && String(k).indexOf('untamed_protection_') === 0; });
    if (key && window[key] && window[key].disabled) return;
  } catch (_) {}

  function initHeader() {
    try {
      // ==========================================
      // DRAWER DRILL-DOWN NAV (snippets/azh-drawer-nav.liquid)
      // L1 buttons open an L2 panel; Back (or closing the drawer) returns to L1.
      // ==========================================
      var dn = document.querySelector('[data-azh-dn]');
      var dnRoot = dn ? dn.querySelector('[data-azh-root]') : null;
      var dnLastBtn = null;
      function dnClose() {
        if (!dn) return;
        dn.querySelectorAll('[data-azh-panel].is-open').forEach(function(p){
          p.classList.remove('is-open');
          p.setAttribute('inert', '');
        });
        dn.querySelectorAll('[data-azh-open][aria-expanded="true"]').forEach(function(b){
          b.setAttribute('aria-expanded', 'false');
        });
        if (dnRoot) dnRoot.removeAttribute('inert');
      }
      function dnOpen(btn) {
        var panel = document.getElementById(btn.getAttribute('data-azh-open'));
        if (!panel) return;
        dnClose();
        panel.removeAttribute('inert');
        panel.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        if (dnRoot) dnRoot.setAttribute('inert', '');
        dnLastBtn = btn;
        // Focus the panel heading (tabindex=-1, no ring) so the level is announced
        // and the next Tab lands on Back.
        var hd = panel.querySelector('[data-azh-hd]');
        if (hd) setTimeout(function(){ hd.focus({ preventScroll: true }); }, 300);
      }
      if (dn) {
        // Search line: close the drawer, then open the search overlay (falls back to /search)
        var dnSearch = dn.querySelector('[data-drawer-search]');
        if (dnSearch) {
          dnSearch.addEventListener('click', function(e){
            if (!(window.AzharaSearch && window.AzharaSearch.open)) return;
            e.preventDefault();
            var close = document.getElementById('mobile-menu-close');
            if (close) close.click();
            setTimeout(function(){ window.AzharaSearch.open(); }, 250);
          });
        }
        dn.addEventListener('click', function(e){
          var openBtn = e.target.closest('[data-azh-open]');
          if (openBtn) { e.preventDefault(); dnOpen(openBtn); return; }
          var backBtn = e.target.closest('[data-azh-back]');
          if (backBtn) {
            e.preventDefault();
            var last = dnLastBtn;
            dnClose();
            if (last) last.focus({ preventScroll: true });
          }
        });
        document.addEventListener('keydown', function(e){
          if (e.key !== 'Escape') return;
          var drawer = document.getElementById('mobile-drawer');
          if (!drawer || !drawer.classList.contains('is-active')) return;
          if (dn.querySelector('[data-azh-panel].is-open')) {
            var last = dnLastBtn;
            dnClose();
            if (last) last.focus({ preventScroll: true });
          } else {
            var close = document.getElementById('mobile-menu-close');
            if (close) close.click();
          }
        });
      }

      var toggles = document.querySelectorAll('.mobile-menu-toggle');
      var mobileClose = document.getElementById('mobile-menu-close');
      var mobileDrawer = document.getElementById('mobile-drawer');
      var overlay = document.getElementById('mobile-drawer-overlay');
      if (toggles.length && mobileDrawer && overlay) {
        toggles.forEach(function(btn){
          btn.addEventListener('click', function(){
            mobileDrawer.classList.add('is-active');
            overlay.classList.add('is-active');
            document.body.style.overflow = 'hidden';
            var fixedHeader = document.getElementById('site-header-fixed');
            if (fixedHeader) fixedHeader.style.display = 'none';
            btn.classList.add('active');
          });
        });
        if (mobileClose) {
          mobileClose.addEventListener('click', function(){
            mobileDrawer.classList.remove('is-active');
            overlay.classList.remove('is-active');
            dnClose();
            document.body.style.overflow = '';
            var fixedHeader = document.getElementById('site-header-fixed');
            if (fixedHeader && window.scrollY > 0) fixedHeader.style.display = '';
            document.querySelectorAll('.mobile-menu-toggle').forEach(function(b){ b.classList.remove('active'); });
          });
        }
        overlay.addEventListener('click', function(){
          mobileDrawer.classList.remove('is-active');
          overlay.classList.remove('is-active');
          dnClose();
          document.body.style.overflow = '';
          var fixedHeader = document.getElementById('site-header-fixed');
          if (fixedHeader && window.scrollY > 0) fixedHeader.style.display = '';
          document.querySelectorAll('.mobile-menu-toggle').forEach(function(b){ b.classList.remove('active'); });
        });
      }

      var mainHeader = document.getElementById('site-header-main');
      if (mainHeader) {
        var stickyType = mainHeader.getAttribute('sticky');
        function updateScrollState(){
          var y = window.scrollY;
          if (y > 10) { mainHeader.classList.add('header--scrolled'); }
          else { mainHeader.classList.remove('header--scrolled'); }
        }
        if (stickyType === 'always') {
          mainHeader.setAttribute('data-sticky-state', 'active');
          window.addEventListener('scroll', updateScrollState, { passive: true });
          updateScrollState();
        } else if (stickyType === 'scroll-up') {
          var lastY = window.scrollY;
          var ticking = false;
          function updateHeader(){
            var y = window.scrollY;
            if (y <= 50) {
              mainHeader.setAttribute('data-sticky-state', 'idle');
            } else if (y < lastY && y > 100) {
              mainHeader.setAttribute('data-sticky-state', 'active');
            } else if (y > lastY) {
              mainHeader.setAttribute('data-sticky-state', 'idle');
            }
            lastY = y;
            ticking = false;
          }
          window.addEventListener('scroll', function(){
            if (!ticking) { requestAnimationFrame(updateHeader); ticking = true; }
          }, { passive: true });
          updateHeader();
        } else if (stickyType === 'never') {
          mainHeader.setAttribute('data-sticky-state', 'idle');
        }
      }

      // ==========================================
      // SIDE CART DRAWER LOGIC
      // Cart markup is server-rendered in header.liquid and refreshed
      // via the Section Rendering API (/?sections=header)
      // ==========================================
      var cartIcon = document.querySelector('.header__cart-icon');
      var floatingCartBtn = document.getElementById('floating-cart-wrapper');
      var cartDrawer = document.getElementById('mobile-cart-drawer');
      var cartClose = document.getElementById('mobile-cart-drawer-close');
      var cartOverlay = document.getElementById('mobile-cart-drawer-overlay');

      var SKELETON_ROW = '<div class="side-cart__skeleton-item">' +
        '<div class="side-cart__skeleton-block side-cart__skeleton-img"></div>' +
        '<div class="side-cart__skeleton-lines">' +
          '<div class="side-cart__skeleton-block side-cart__skeleton-line"></div>' +
          '<div class="side-cart__skeleton-block side-cart__skeleton-line side-cart__skeleton-line--short"></div>' +
          '<div class="side-cart__skeleton-block side-cart__skeleton-line side-cart__skeleton-line--tiny"></div>' +
        '</div></div>';
      var SKELETON_HTML = '<div class="side-cart__skeleton" aria-hidden="true">' + SKELETON_ROW + SKELETON_ROW + SKELETON_ROW + '</div>';

      // True whenever the cart has changed and the drawer markup may not reflect it yet
      var cartMarkupStale = false;
      var cartRefreshPromise = null;
      var cartRefreshQueued = false;
      var cartRefreshRetries = 0;

      function sectionsRoot() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      }

      // Canonical price format: rupee symbol, Indian commas, no paise
      function formatMoneyINR(cents) {
        var rupees = Math.round(cents / 100);
        return '₹' + rupees.toLocaleString('en-IN');
      }

      // Keep the upsell list stable for the whole session (no reshuffle on cart changes)
      function seedUpsell(scope) {
        var scroll = (scope || document).querySelector('.side-cart__upsell-scroll');
        if (!scroll) return;
        try {
          var stored = sessionStorage.getItem('azhara-side-cart-upsell');
          if (stored) {
            scroll.innerHTML = stored;
          } else {
            sessionStorage.setItem('azhara-side-cart-upsell', scroll.innerHTML);
          }
        } catch (_) {}
      }

      function updateCartCounts(count) {
        document.querySelectorAll('.cart-count').forEach(function(span) {
          span.innerText = count;
          span.style.display = count > 0 ? 'flex' : 'none';
        });
        var sideCartCount = document.querySelector('.side-cart__count[data-cart-count]');
        if (sideCartCount) {
          sideCartCount.textContent = '(' + count + ' ' + (count === 1 ? 'item' : 'items') + ')';
        }
        document.querySelectorAll('[data-mobile-cart-count]').forEach(function(span) {
          span.textContent = count;
        });
      }

      // Applies fresh section markup to the drawer. Returns false (without
      // touching the DOM) when the section render lags behind the cart API,
      // which happens for a beat right after a mutation.
      function renderSideCartFromHtml(html, authoritativeCount, force) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newContent = doc.getElementById('mobile-cart-drawer-content');
        if (!force && newContent && typeof authoritativeCount === 'number') {
          var renderedQty = 0;
          newContent.querySelectorAll('.side-cart__item [data-qty-value]').forEach(function(el) {
            renderedQty += parseInt(el.textContent, 10) || 0;
          });
          if (renderedQty !== authoritativeCount) return false;
        }
        var currentContent = document.getElementById('mobile-cart-drawer-content');
        if (newContent && currentContent) {
          var scrollTop = currentContent.scrollTop;
          currentContent.innerHTML = newContent.innerHTML;
          seedUpsell(currentContent);
          currentContent.scrollTop = scrollTop;
        }
        var newCount = doc.querySelector('.side-cart__count[data-cart-count]');
        var curCount = document.querySelector('.side-cart__count[data-cart-count]');
        if (newCount && curCount) {
          curCount.textContent = newCount.textContent.trim();
        }
        var newFooter = doc.querySelector('[data-cart-footer]');
        var curFooter = document.querySelector('[data-cart-footer]');
        if (newFooter && curFooter) {
          curFooter.innerHTML = newFooter.innerHTML;
        }
        cartMarkupStale = false;
        return true;
      }

      // Fetches fresh cart markup via the Section Rendering API, alongside
      // /cart.js as the source of truth for counts. Returns a promise that
      // resolves once the drawer has been re-rendered.
      function refreshSideCart() {
        if (!cartDrawer) return Promise.resolve();
        if (cartRefreshPromise) {
          cartRefreshQueued = true;
          return cartRefreshPromise;
        }
        cartRefreshPromise = Promise.all([
          fetch(sectionsRoot() + '?sections=header', { cache: 'no-store' }).then(function(response) {
            if (!response.ok) throw new Error('Cart refresh failed: ' + response.status);
            return response.json();
          }),
          fetch('/cart.js', { cache: 'no-store' }).then(function(response) {
            if (!response.ok) throw new Error('Cart fetch failed: ' + response.status);
            return response.json();
          })
        ])
          .then(function(results) {
            var sections = results[0];
            var cart = results[1];
            updateCartCounts(cart.item_count);
            if (!(sections && sections.header)) return true;
            return renderSideCartFromHtml(sections.header, cart.item_count, cartRefreshRetries >= 3);
          })
          .catch(function(err) {
            console.error('Error refreshing side cart:', err);
            var content = document.getElementById('mobile-cart-drawer-content');
            if (content && content.querySelector('.side-cart__skeleton')) {
              content.innerHTML = '<div class="side-cart__loading">Unable to load your cart. <a href="/cart">View cart</a></div>';
            }
            return true;
          })
          .then(function(fresh) {
            cartRefreshPromise = null;
            if (!fresh && cartRefreshRetries < 3) {
              cartRefreshRetries++;
              return new Promise(function(resolve) {
                setTimeout(function() {
                  resolve(refreshSideCart());
                }, 350);
              });
            }
            cartRefreshRetries = 0;
            resetOpacity();
            if (cartRefreshQueued) {
              cartRefreshQueued = false;
              return refreshSideCart();
            }
          });
        return cartRefreshPromise;
      }

      function openSideCart(e) {
        if (!(cartDrawer && cartOverlay)) return;
        if (e && e.preventDefault) e.preventDefault();
        var wasOpen = cartDrawer.classList.contains('is-active');
        cartDrawer.classList.add('is-active');
        cartOverlay.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        // Hide floating cart button when side cart is open
        if (floatingCartBtn) {
          floatingCartBtn.classList.add('fc-hidden-by-cart');
        }
        // If the cart just changed, never show stale markup: swap in a
        // skeleton and wait for the fresh section render. When the drawer
        // is already open the in-flight refresh patches it in place.
        if (cartMarkupStale || cartRefreshPromise) {
          if (!wasOpen) {
            var content = document.getElementById('mobile-cart-drawer-content');
            if (content && !content.querySelector('.side-cart__skeleton')) {
              content.innerHTML = SKELETON_HTML;
            }
          }
          refreshSideCart();
        }
      }

      // Make openSideCart globally available for cart add events
      window.openSideCart = openSideCart;

      // Header cart icon opens side cart drawer
      if (cartIcon) {
        cartIcon.addEventListener('click', openSideCart);
      }

      // Floating cart button also opens side cart drawer
      if (floatingCartBtn) {
        floatingCartBtn.addEventListener('click', openSideCart);
      }

      function closeCart() {
        if (cartDrawer) cartDrawer.classList.remove('is-active');
        if (cartOverlay) cartOverlay.classList.remove('is-active');
        document.body.style.overflow = '';
        // Show floating cart button when side cart is closed
        if (floatingCartBtn) {
          floatingCartBtn.classList.remove('fc-hidden-by-cart');
        }
      }

      if (cartClose) cartClose.addEventListener('click', closeCart);
      if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

      // ==========================================
      // SIDE CART QUANTITY & REMOVE HANDLERS
      // ==========================================

      // Quantity buttons (using event delegation)
      document.addEventListener('click', function(e) {
        var qtyBtn = e.target.closest('.side-cart__qty-btn');
        if (qtyBtn && !qtyBtn.disabled) {
          e.preventDefault();
          var action = qtyBtn.dataset.action;
          var itemKey = qtyBtn.dataset.itemKey;
          var qtyDisplay = qtyBtn.closest('.side-cart__qty-selector').querySelector('.side-cart__qty-value');
          var currentQty = parseInt(qtyDisplay.textContent, 10) || 0;
          var newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
          updateCartItem(itemKey, newQty);
        }
      });

      // Remove button
      document.addEventListener('click', function(e) {
        var removeBtn = e.target.closest('.side-cart__item-remove');
        if (removeBtn && !removeBtn.disabled) {
          e.preventDefault();
          updateCartItem(removeBtn.dataset.itemKey, 0);
        }
      });

      // Checkout button
      document.addEventListener('click', function(e) {
        var checkoutBtn = e.target.closest('[data-side-cart-checkout]');
        if (checkoutBtn && !checkoutBtn.disabled) {
          var discountCode = sessionStorage.getItem('discount_code');
          var checkoutUrl = '/checkout';
          if (discountCode) {
            checkoutUrl += '?discount=' + encodeURIComponent(discountCode);
          }
          window.location.href = checkoutUrl;
        }
      });

      // ==========================================
      // OFFERS PANEL TOGGLE
      // ==========================================
      var offersPanel = document.querySelector('[data-offers-panel]');

      // Open offers panel
      document.addEventListener('click', function(e) {
        var offersToggle = e.target.closest('[data-offers-toggle]');
        if (offersToggle && offersPanel) {
          e.preventDefault();
          offersPanel.classList.add('is-open');
        }
      });

      // Close offers panel
      document.addEventListener('click', function(e) {
        var offersClose = e.target.closest('[data-offers-close]');
        if (offersClose && offersPanel) {
          e.preventDefault();
          offersPanel.classList.remove('is-open');
        }
      });

      // Close offers panel when cart is closed
      var originalCloseCart = closeCart;
      closeCart = function() {
        if (offersPanel) offersPanel.classList.remove('is-open');
        originalCloseCart();
      };

      // ==========================================
      // SECURE BAND TOGGLE TEXT
      // ==========================================
      (function() {
        var texts = document.querySelectorAll('.side-cart__secure-toggle-text');
        if (texts.length < 2) return;
        var current = 0;
        setInterval(function() {
          texts[current].classList.remove('side-cart__secure-toggle-text--visible');
          current = (current + 1) % texts.length;
          texts[current].classList.add('side-cart__secure-toggle-text--visible');
        }, 3000);
      })();

      function resetOpacity() {
        document.querySelectorAll('.side-cart__item').forEach(function(item) {
          item.style.opacity = '1';
        });
      }

      // ==========================================
      // CART UPDATE FUNCTION (optimistic UI)
      // ==========================================
      function updateCartItem(id, quantity) {
        cartMarkupStale = true;
        var row = document.querySelector('.side-cart__item[data-item-key="' + id + '"]');
        if (row) {
          // Disable this row's steppers/remove while the request is in flight
          row.querySelectorAll('.side-cart__qty-btn, .side-cart__item-remove').forEach(function(btn) {
            btn.disabled = true;
          });
          var qtyDisplay = row.querySelector('[data-qty-value]');
          var oldQty = parseInt(qtyDisplay ? qtyDisplay.textContent : '0', 10) || 0;
          if (quantity === 0) {
            row.style.opacity = '0.4';
          } else if (qtyDisplay) {
            qtyDisplay.textContent = quantity;
          }
          // Optimistically update the subtotal from the known unit price
          var unitPrice = parseInt(row.getAttribute('data-unit-price'), 10);
          var subtotalEl = document.querySelector('[data-subtotal]');
          if (!isNaN(unitPrice) && subtotalEl) {
            var subtotalCents = parseInt(subtotalEl.getAttribute('data-subtotal-cents'), 10);
            if (!isNaN(subtotalCents)) {
              var newSubtotal = Math.max(0, subtotalCents + unitPrice * (quantity - oldQty));
              subtotalEl.setAttribute('data-subtotal-cents', newSubtotal);
              subtotalEl.textContent = formatMoneyINR(newSubtotal);
            }
          }
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: quantity })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Cart update failed: ' + res.status);
          return res.json();
        })
        .then(function(cart) {
          // Exact counts/totals from the change response, then reconcile markup
          updateCartCounts(cart.item_count);
          var subtotalEl = document.querySelector('[data-subtotal]');
          if (subtotalEl) {
            subtotalEl.setAttribute('data-subtotal-cents', cart.total_price);
            subtotalEl.textContent = formatMoneyINR(cart.total_price);
          }
          return refreshSideCart();
        })
        .catch(function(err) {
          console.error('Error updating cart:', err);
          // Reconcile with server truth so optimistic state never sticks
          refreshSideCart();
        });
      }

      // ==========================================
      // LISTEN FOR CART UPDATE EVENTS
      // ==========================================
      document.addEventListener('cart:updated', function() {
        if (window.refreshSideCart) window.refreshSideCart();
        if (window.refreshHeaderCart) window.refreshHeaderCart();
      });

      document.addEventListener('cart:refresh', function() {
        if (window.refreshSideCart) window.refreshSideCart();
        if (window.refreshHeaderCart) window.refreshHeaderCart();
      });

      // Reconcile after back/forward cache restores
      window.addEventListener('pageshow', function(ev) {
        if (ev.persisted) {
          cartMarkupStale = true;
          refreshSideCart();
          if (window.refreshHeaderCart) window.refreshHeaderCart();
        }
      });

      // Expose refreshSideCart globally. External callers invoke it because the
      // cart just changed, so mark the drawer markup stale first.
      window.refreshSideCart = function() {
        cartMarkupStale = true;
        return refreshSideCart();
      };

      // ==========================================
      // UPDATE HEADER CART COUNT (global function)
      // ==========================================
      var _refreshHeaderCartTimer = null;
      window.refreshHeaderCart = function() {
        clearTimeout(_refreshHeaderCartTimer);
        _refreshHeaderCartTimer = setTimeout(function() {
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              updateCartCounts(cart.item_count);
            })
            .catch(function(e) { console.error(e); });
        }, 50);
      };

      // Seed the upsell list from this session's first render
      seedUpsell(document);

    } catch (_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }
})();
